import { gql } from 'react-apollo';

export default gql`
  mutation createWatersInvestorUser($input: CreateWatersInvestorUserInput!) {
    createWatersInvestorUser(input: $input) {
      _id
      firstName
      lastName
      email
      offerId
      address
      amount
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/createWatersInvestorUser.js